import React from "react";
import { useTranslation } from "react-i18next";
import { Box, ListItemIcon, MenuItem, Select } from "@mui/material";

import {
  BookingType,
  EVENT_TYPES,
  EVENT_TYPE_MAP,
} from "../../../../../eventTypes";
import Field from "../Field";

interface EventTypeSelectProps {
  value: BookingType;
  onChange: (value: BookingType) => void;
}

const EventTypeSelect: React.FC<EventTypeSelectProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation("calendar");

  return (
    <Field label={t("booking.event_type")}>
      <Select
        fullWidth
        size="small"
        value={value}
        onChange={(e) => onChange(e.target.value as BookingType)}
        renderValue={(val) => {
          const meta = EVENT_TYPE_MAP[val as BookingType];
          const Icon = meta.icon;
          return (
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Icon sx={{ color: meta.color, fontSize: 18 }} />
              {meta.label}
            </Box>
          );
        }}
      >
        {EVENT_TYPES.map((option) => {
          const Icon = option.icon;
          return (
            <MenuItem key={option.id} value={option.id}>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <Icon sx={{ color: option.color, fontSize: 18 }} />
              </ListItemIcon>
              {option.label}
            </MenuItem>
          );
        })}
      </Select>
    </Field>
  );
};

export default EventTypeSelect;
